/*
 * HairMNL custom theme JS — Pipeline 8 add-on
 * Split from hairmnl-custom.js per bd ujg6.14
 * Common behaviours loaded on every template:
 *
 *   3) header-mobile-slide-rule (~88 LoC)
 *   4) lion-points (~22 LoC)
 *   5) domparser (~12 LoC)
 *   6) hover-line (~130 LoC)
 *   7) cart-drawer-on-atc (~55 LoC)
 */

(function () {
  'use strict';

  // ============================================================
  // 3) header-mobile-slide-rule — mobile nav slide-rule pattern
  // ----------------------------------------------------------------
  // Pipeline 6 version had 4 console.log statements firing per construction
  // (INP issue, partially noted 2026-05-01 T5). This port:
  //   - Strips ALL console.log statements (INP win)
  //   - Adds the missing `wrapper` selector key the original referenced via
  //     `selectors.wrapper` but never defined
  //   - Keeps the keyboard event handler (was defined but never called in P6)
  //   - Replaces deprecated `evt.which` with `evt.code`
  // ============================================================
  (function () {
    var SELECTORS = {
      slideruleOpen: 'data-tousled-sliderule-open',
      slideruleClose: 'data-tousled-sliderule-close',
      sliderulePane: 'data-tousled-sliderule-pane',
      slideruleWrapper: '[data-tousled-sliderule]',
      slideruleWrapperContainer: '[data-tousled-sliderule-wrapper]',
      focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      children: ':scope > [data-animates], :scope > * > [data-animates], :scope > * > * >[data-animates], :scope > .sliderule-grid  > *',
    };
    var CLASSES = { isVisible: 'is-visible' };

    var HeaderMobileSliderule = function (el) {
      this.sliderule = el;
      this.wrapper = el.closest(SELECTORS.slideruleWrapperContainer);
      this.key = this.sliderule.id;
      this.trigger = document.querySelector('[' + SELECTORS.slideruleOpen + '=\'' + this.key + '\']');
      this.exit = document.querySelector('[' + SELECTORS.slideruleClose + '=\'' + this.key + '\']');
      this.pane = document.querySelector('[' + SELECTORS.sliderulePane + ']');
      this.children = this.sliderule.querySelectorAll(SELECTORS.children);

      if (!this.trigger || !this.exit || !this.pane) return;

      this.trigger.setAttribute('aria-haspopup', true);
      this.trigger.setAttribute('aria-expanded', false);
      this.trigger.setAttribute('aria-controls', this.key);

      this._bindClicks();
      this._bindKeys();
      this._stagger();
      document.addEventListener('theme:sliderule:close', this._close.bind(this));
    };

    HeaderMobileSliderule.prototype._bindClicks = function () {
      this.trigger.addEventListener('click', this._show.bind(this));
      this.exit.addEventListener('click', this._hide.bind(this));
    };
    HeaderMobileSliderule.prototype._bindKeys = function () {
      this.trigger.addEventListener('keyup', function (evt) {
        if (evt.code !== 'Space') return;
        this._show();
      }.bind(this));
      this.sliderule.addEventListener('keyup', function (evt) {
        if (evt.code !== 'Escape') return;
        this._hide();
      }.bind(this));
    };
    HeaderMobileSliderule.prototype._stagger = function () {
      this.children.forEach(function (child, i) {
        child.style.transitionDelay = (i * 50 + 10) + 'ms';
      });
    };
    HeaderMobileSliderule.prototype._show = function () {
      this.sliderule.classList.add(CLASSES.isVisible);
      this.children.forEach(function (el) { el.classList.add(CLASSES.isVisible); });
      var pos = parseInt(this.pane.dataset.sliderulePane, 10) + 1;
      this.pane.setAttribute('data-sliderule-pane', pos);
    };
    HeaderMobileSliderule.prototype._hide = function () {
      this.sliderule.classList.remove(CLASSES.isVisible);
      this.children.forEach(function (el) { el.classList.remove(CLASSES.isVisible); });
      var pos = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute('data-sliderule-pane', pos);
    };
    HeaderMobileSliderule.prototype._close = function () {
      if (!this.pane || !this.pane.hasAttribute(SELECTORS.sliderulePane)) return;
      if (parseInt(this.pane.getAttribute(SELECTORS.sliderulePane), 10) > 0) {
        this._hide();
        this.pane.setAttribute(SELECTORS.sliderulePane, 0);
      }
    };

    document.querySelectorAll(SELECTORS.slideruleWrapper).forEach(function (el) {
      new HeaderMobileSliderule(el);
    });
  })();

  // ============================================================
  // 4) lion-points — LoyaltyLion points label reveal (M5 port)
  // ----------------------------------------------------------------
  // Polls .points-approved spans for the LoyaltyLion-injected points
  // value, then unhides .points-label once any are populated.
  // Only runs for logged-in users (navlink-account.is-loggedin).
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    var navlinkAccounts = document.querySelectorAll('.navlink-account.is-loggedin');
    if (!navlinkAccounts.length) return;

    var pointsApproved = document.querySelectorAll('.points-approved');
    var pointsLabel = document.querySelectorAll('.points-label');
    pointsApproved.forEach(function (el) {
      var interval = setInterval(function () {
        if (el.innerHTML !== '') {
          clearInterval(interval);
          pointsLabel.forEach(function (label) { label.style.display = 'block'; });
        }
      }, 1000);
    });
  });

  // ============================================================
  // 5) domparser — strip HTML from metafield multi-line text (M5 port)
  // ----------------------------------------------------------------
  // Pipeline 6 used node-html-parser (5400 LoC library) to do what
  // textContent=textContent does natively. Carries over the same fix.
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.metafield-multi_line_text_field').forEach(function (el) {
      el.textContent = el.textContent;
    });
  });

  // ============================================================
  // 6) hover-line — TousledHoverLine animated underline (M5 port)
  // ----------------------------------------------------------------
  // Pure DOM + CSS-variable manipulation. No vendor deps. Preserves
  // the INP-fix discipline from the P6 version (batch reads before
  // writes; geometry reads kept separate from setProperty calls).
  // ============================================================
  (function () {
    var SEL = {
      item: '[data-main-menu-text-item]',
      text: '.navtext',
      isActive: 'data-menu-active',
      sectionOuter: '[data-tousled-header-wrapper]',
      underlineCurrent: 'data-underline-current',
      defaultItem: '.menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext',
    };
    var defaultPositions = null;

    var TousledHoverLine = function (el) {
      this.wrapper = el;
      this.itemList = this.wrapper.querySelectorAll(SEL.item);
      this.sectionOuter = document.querySelector(SEL.sectionOuter);
      if (!this.sectionOuter) return;
      this.underlineCurrent = this.sectionOuter.getAttribute(SEL.underlineCurrent) === 'true';
      this.defaultItem = this.underlineCurrent ? this.wrapper.querySelector(SEL.defaultItem) : null;
      this.textBottom = null;
      this._setDefault();
      document.fonts.ready.then(this._init.bind(this));
    };
    TousledHoverLine.prototype._init = function () {
      if (!this.itemList.length) return;
      this._listen();
      document.addEventListener('theme:resize', this._reset.bind(this));
      var vert = this._measure();
      this._setDefault();
      var barLeftDefault = null;
      var barLeftElse = null;
      var navItemInit = this.sectionOuter.querySelector(SEL.item);
      if (defaultPositions) {
        if (this.defaultItem) barLeftDefault = this.defaultItem.offsetLeft || 0;
      } else if (navItemInit) {
        barLeftElse = Math.ceil(navItemInit.getBoundingClientRect().left + window.scrollX);
      } else {
        barLeftElse = 0;
      }
      this._applyVertical(vert.textHeight, vert.textBottom);
      if (defaultPositions) {
        if (this.defaultItem) this.sectionOuter.style.setProperty('--bar-left', barLeftDefault + 'px');
        this._applyResetStyles();
      } else {
        this.sectionOuter.style.setProperty('--bar-left', barLeftElse + 'px');
        this.sectionOuter.style.setProperty('--bar-width', '0px');
      }
      this.sectionOuter.style.setProperty('--bar-opacity', '1');
    };
    TousledHoverLine.prototype._setDefault = function () {
      if (!this.defaultItem) return;
      defaultPositions = { left: this.defaultItem.offsetLeft || null, width: this.defaultItem.clientWidth || null };
    };
    TousledHoverLine.prototype._measure = function () {
      var height = this.wrapper.clientHeight;
      var text2 = this.itemList[0].querySelector(SEL.text);
      var textHeight = text2.clientHeight;
      var textBottom = Math.floor(height / 2 - textHeight / 2) - 4;
      return { textHeight: textHeight, textBottom: textBottom };
    };
    TousledHoverLine.prototype._applyVertical = function (textHeight, textBottom) {
      if (this.textBottom !== textBottom) {
        this.sectionOuter.style.setProperty('--bar-text', textHeight + 'px');
        this.sectionOuter.style.setProperty('--bar-bottom', textBottom + 'px');
        this.textBottom = textBottom;
      }
    };
    TousledHoverLine.prototype._listen = function () {
      var self = this;
      this.itemList.forEach(function (element) {
        element.addEventListener('mouseenter', function (evt) {
          var item = evt.target.querySelector(SEL.text);
          self._startBar(item);
        });
      });
      this.wrapper.addEventListener('mouseleave', this._clearBar.bind(this));
    };
    TousledHoverLine.prototype._startBar = function (item) {
      var vert = this._measure();
      var leftPos = Math.ceil(item.getBoundingClientRect().left + window.scrollX);
      var width = item.clientWidth;
      var active = this.sectionOuter.getAttribute(SEL.isActive) !== 'false';
      this._applyVertical(vert.textHeight, vert.textBottom);
      if (active) {
        this._render(width, leftPos);
      } else {
        this.sectionOuter.setAttribute(SEL.isActive, true);
        this._render(0, leftPos);
        var self = this;
        setTimeout(function () { self._render(width, leftPos); }, 10);
      }
    };
    TousledHoverLine.prototype._render = function (width, left) {
      this.sectionOuter.style.setProperty('--bar-left', left + 'px');
      this.sectionOuter.style.setProperty('--bar-width', width + 'px');
    };
    TousledHoverLine.prototype._applyResetStyles = function () {
      if (defaultPositions && defaultPositions.left && defaultPositions.width) {
        this.sectionOuter.style.setProperty('--bar-left', defaultPositions.left + 'px');
        this.sectionOuter.style.setProperty('--bar-width', defaultPositions.width + 'px');
      } else {
        this.sectionOuter.style.setProperty('--bar-width', '0px');
      }
    };
    TousledHoverLine.prototype._reset = function () {
      this._setDefault();
      this._applyResetStyles();
    };
    TousledHoverLine.prototype._clearBar = function () {
      var self = this;
      this.sectionOuter.setAttribute(SEL.isActive, false);
      setTimeout(function () {
        var active = self.sectionOuter.getAttribute(SEL.isActive) !== 'false';
        if (!active) self._reset();
      }, 150);
    };

    var container = document.querySelector('[data-tousled-header-wrapper]');
    if (container) {
      var el = container.querySelector('[data-links-wrapper]');
      if (el) new TousledHoverLine(el);
    }
  })();

  // ============================================================
  // 7) cart-drawer-on-atc — P6 UX parity for add-to-cart
  // ----------------------------------------------------------------
  // Pipeline 6's add-to-cart slid the cart drawer open immediately on
  // success. Pipeline 8's stock flow instead shows a mini product popdown
  // (the `bo` class in theme.js dispatches `theme:cart:popdown`, then the
  // user has to click "View Cart" in the popdown to actually open the
  // drawer). Reads as "slide cart drawer doesn't work" for anyone used to
  // the P6 behavior — the drawer is healthy, the user just never sees it
  // because the popdown intercepts the event.
  //
  // Fix (v2): catch `theme:cart:popdown` in the capture phase to suppress
  // the mini popdown. Set a flag, then open the drawer on the NEXT
  // `theme:cart:change` event. P8's onSuccess() calls updateHeaderTotal()
  // (async /cart.js fetch) before dispatching `theme:cart:popdown`
  // synchronously. Opening the drawer immediately on the popdown event
  // caused it to open with stale content because theme:cart:change (which
  // sets stale=true on the drawer's AJAX cart controller) hadn't fired yet.
  // Waiting for theme:cart:change guarantees the drawer's controller has
  // fresh cart data and stale=true, so loadHTML() renders the added item.
  (function () {
    var pendingOpen = false;

    document.addEventListener('theme:cart:popdown', function (e) {
      e.stopImmediatePropagation();
      pendingOpen = true;
    }, true);

    document.addEventListener('theme:cart:change', function () {
      if (!pendingOpen) return;
      pendingOpen = false;
      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (!drawer) return;
      // J30 (bd 2i8b.83): defer the open one tick. This listener registers BEFORE
      // theme.js's drawer controller registers its own theme:cart:change listener,
      // so opening synchronously painted the drawer before the controller had
      // marked itself stale with the fresh cart (stale first paint on 2nd+ adds).
      // One tick later every listener on this event has run and loadHTML()
      // renders the fresh cart.
      setTimeout(function () {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      }, 0);
    }, false);
  })();

  // ============================================================
  // 8) lazy-render — IntersectionObserver Section Rendering API (bd ujg6.18)
  // ----------------------------------------------------------------
  // Below-fold heavy sections (featured-collections, brand-grid,
  // related-products) render as lightweight placeholders on pageload
  // and are fetched via Shopify's Section Rendering API when they
  // approach the viewport. Reduces initial page weight and TTI on
  // mobile. Triggered when the placeholder is 200px from viewport
  // edge. Non-JS users and crawlers see the <noscript> fallback.
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    var placeholders = document.querySelectorAll('[data-lazy-render]');
    if (!placeholders.length) return;

    var pending = new Set();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var url = el.getAttribute('data-lazy-url');
        if (!url || pending.has(url)) return;

        pending.add(url);
        observer.unobserve(el);

        fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error('Section fetch failed: ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var sid = el.getAttribute('data-section-id');
            // ----------------------------------------------------------------
            // bd 2i8b.30 + 2i8b.34 — Parse with DOMParser from the start.
            //
            // section-collection.liquid (and brand-collection / related)
            // use `{%- if request.design_mode or request.page_type == null -%}`
            // to detect Section Rendering API requests. Shopify does NOT
            // null out request.page_type for ?section_id= requests, so the
            // API returns the SAME lazy-render placeholder + a <noscript>
            // fallback containing the actual products. We extract from
            // the <noscript>.
            //
            // Key: DOMParser('text/html') parses with "scripting disabled"
            // context, so <noscript> contents become real DOM children
            // (not opaque text as they would in a JS-enabled
            // innerHTML parse). The earlier innerHTML approach collapsed
            // nested <noscript>s inside each product card, losing 11/12
            // products. bd 2i8b.34
            // ----------------------------------------------------------------
            var doc = new DOMParser().parseFromString(html, 'text/html');
            // Find a non-placeholder section first (in case the page_type
            // detection ever starts working)
            var candidates = doc.querySelectorAll('[data-section-id="' + sid + '"]');
            var fetched = null;
            for (var i = 0; i < candidates.length; i++) {
              if (!candidates[i].hasAttribute('data-lazy-render')) {
                fetched = candidates[i];
                break;
              }
            }
            // If only placeholder candidates found, use the <noscript>
            // fallback content. In DOMParser-parsed docs, noscript children
            // ARE real DOM nodes.
            if (!fetched) {
              var noscripts = doc.querySelectorAll('noscript');
              for (var j = 0; j < noscripts.length; j++) {
                var match = noscripts[j].querySelector('[data-section-id="' + sid + '"]');
                if (match) {
                  fetched = match;
                  break;
                }
              }
            }
            // Last resort: use first matching element regardless
            if (!fetched && candidates.length) fetched = candidates[0];
            if (fetched) fetched = document.adoptNode(fetched);
            if (fetched) {
              el.replaceWith(fetched);
              // Dispatch a custom event so any section-specific init code can re-run
              fetched.dispatchEvent(new CustomEvent('section:lazy-rendered', { bubbles: true }));
            } else {
              // Fallback: if we couldn't find the specific wrapper, use the whole response
              el.innerHTML = html;
            }
          })
          .catch(function (err) {
            // Show the <noscript> fallback (it's a sibling of the placeholder)
            var fallback = el.nextElementSibling;
            if (fallback && fallback.tagName === 'NOSCRIPT') {
              var div = document.createElement('div');
              div.innerHTML = fallback.textContent;
              el.replaceWith(div.firstElementChild || div);
            }
            pending.delete(url);
          });
      });
    }, { rootMargin: '200px 0px' });

    placeholders.forEach(function (el) { observer.observe(el); });
  });

  // ============================================================
  // 9) YouTube Facade — click-to-load (bd hairmnl-theme-ujg6.41)
  // ----------------------------------------------------------------
  // section-double.liquid's 'youtube' block renders a <button.yt-facade>
  // with a thumbnail in place of an <iframe>. On click, swap to a real
  // iframe with autoplay=1 so playback starts immediately.
  //
  // Why: loading="lazy" on iframes is ignored when the iframe is already
  // in initial viewport (brand-page hero is above the fold). YouTube
  // player CSS + JS (~1.4 MB) was loading on cold pageload despite the
  // lazy attribute. Facade defers all youtube.com network requests
  // until the user opts in.
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.yt-facade');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-yt-facade');
    if (!vid) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0&hd=1';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.aspectRatio = '16/9';
    iframe.style.border = '0';
    btn.replaceWith(iframe);
  });

  // ============================================================
  // bd a7av.8 — Sticky-bar collection-mode hydration + card-click update.
  // ----------------------------------------------------------------
  // When sections/collection.liquid (or brand-collection.liquid) renders
  // {% render 'product-sticky-bar', is_collection: true %}, the snippet
  // outputs a bar pre-filled with the FIRST product in the collection as
  // a server-rendered fallback. This block then:
  //   1) on DOM ready: if sessionStorage has a `hairmnl_last_viewed_product`,
  //      replace the bar's content with that product instead of the fallback.
  //   2) on product-card click within the collection page, update the bar
  //      to feature THAT product (no nav — let the link navigate the card,
  //      and the new PDP's PDP-mode bar will be visible there too).
  //   3) hide the bar entirely on cart / search / account / checkout pages
  //      (defensive — render call should also be omitted from those templates).
  //
  // Hidden by default below 1024px (CSS gate in css-overrides.liquid).
  // ============================================================
  (function () {
    var bar = document.getElementById('vrec-product-sticky-bar');
    if (!bar) return;
    if (bar.getAttribute('data-vrec-sticky-mode') !== 'collection') return;

    // Defensive hide on excluded surfaces.
    var path = window.location.pathname;
    if (/^\/(cart|search|account|checkout)/.test(path)) {
      bar.style.display = 'none';
      return;
    }

    // Helper: update the bar DOM in-place from a payload object.
    function applyPayload(p) {
      if (!p || !p.id) return;
      bar.setAttribute('data-product-id', p.id);
      bar.setAttribute('data-product-handle', p.handle || '');
      bar.setAttribute('data-product-url', p.url || '');

      var titleEl = bar.querySelector('.vrec-product-sticky-bar__title');
      if (titleEl && p.title) titleEl.textContent = p.title;

      var thumbImg = bar.querySelector('.vrec-product-sticky-bar__thumb img');
      if (thumbImg && p.thumb_src) thumbImg.src = p.thumb_src;

      var priceEl = bar.querySelector('.vrec-product-sticky-bar__price');
      if (priceEl && p.price_html) priceEl.innerHTML = p.price_html;

      var variantEl = bar.querySelector('[data-vrec-sticky-variant]');
      if (variantEl && p.variant_label) variantEl.textContent = p.variant_label;

      var idInput = bar.querySelector('[data-vrec-sticky-id]');
      if (idInput && p.variant_id) idInput.value = p.variant_id;

      var btn = bar.querySelector('.vrec-product-sticky-bar__cta');
      if (btn && typeof p.available !== 'undefined') {
        btn.disabled = !p.available;
        btn.setAttribute('aria-disabled', String(!p.available));
      }
    }

    // Hydrate from sessionStorage if a previously-viewed product exists
    // AND it's newer than the server-rendered fallback (always treat
    // sessionStorage as more recent on collection pages).
    try {
      var stored = sessionStorage.getItem('hairmnl_last_viewed_product');
      if (stored) {
        var p = JSON.parse(stored);
        // Sanity: stale entries (>2hr) get ignored — operator could have a
        // long tab open while the catalog changes. Falls back to the
        // first-product server render in that case.
        if (p && p.ts && (Date.now() - p.ts) < 2 * 60 * 60 * 1000) {
          applyPayload(p);
        }
      }
    } catch (e) { /* sessionStorage disabled or parse error — keep fallback */ }

    // Card-click handler: when user clicks a product card on the collection
    // page, capture the product info and update the bar immediately. The
    // anchor's natural navigation continues to PDP after this synchronously
    // returns (no preventDefault).
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.product-grid-item, [data-product-grid-item]');
      if (!card) return;
      var anchor = card.querySelector('a[href*="/products/"]');
      if (!anchor) return;

      // Best-effort scrape from the card DOM (the home/collection card markup).
      // Falls back gracefully if any field is missing.
      var titleEl = card.querySelector('.product__grid__title, .product-grid-item__title, [class*="title"]');
      var priceEl = card.querySelector('.product__grid__price, .product-grid-item__price, [class*="price"]');
      var imgEl = card.querySelector('img');
      var handleMatch = anchor.href.match(/\/products\/([^/?#]+)/);

      var payload = {
        id: card.getAttribute('data-product-id') || '',
        handle: handleMatch ? handleMatch[1] : '',
        url: anchor.getAttribute('href') || '',
        title: titleEl ? titleEl.textContent.trim() : '',
        price_html: priceEl ? priceEl.innerHTML : '',
        thumb_src: imgEl ? imgEl.currentSrc || imgEl.src : '',
        variant_id: '',         // collection card has no variant info; ADD will redirect to PDP
        variant_label: '',
        available: true,
        ts: Date.now()
      };

      // Update bar visually for any brief moment before navigation.
      applyPayload(payload);

      // Persist for the next collection-page visit.
      try { sessionStorage.setItem('hairmnl_last_viewed_product', JSON.stringify(payload)); }
      catch (err) { /* sessionStorage disabled */ }
    });
  })();

  // ============================================================
  // 10) rec-card AJAX add-to-cart (bd a7av.10 / 2i8b.50 + 2i8b.51)
  // ----------------------------------------------------------------
  // Vertex rec cards on the cart page + cart drawer use a formless
  // <button data-vrec-add data-variant-id> (snippets/vertex-rec-card.liquid)
  // instead of a per-card {% form 'product' %} — a nested <form> is invalid
  // inside the cart page form (sections/cart.liquid) and the drawer form
  // (cart-drawer.liquid). This handler adds via /cart/add.js and REUSES the
  // theme's existing flow (no parallel cart state): it re-dispatches the same
  // events the stock form-submit onSuccess fires — theme:cart:popdown (caught
  // + flagged by §7) then theme:cart:change (which §7 uses to open the drawer
  // and the drawer's AJAX controller uses to reload its line items). The
  // header count/price are read from the authoritative /cart.js.
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vrec-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation(); // J18b (a7av.30): capture-phase + stop so STKY's leftover ScriptTag
                         // click handler on a parent can't navigate to the PDP first (preview only)
    if (btn.getAttribute('aria-busy') === 'true') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // bd a7av.15: fly-to-cart animation (STKY parity). Best-effort + reduced-motion
    // aware; runs on click so it feels responsive while the add request is in flight.
    try { flyToCart(btn); } catch (flyErr) {}

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error((j && j.description) || ('add failed: ' + r.status));
          });
        }
        return r.json();
      })
      .then(function () {
        // Read the authoritative cart and update the header count/price.
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var countEl = document.querySelector('[data-header-cart-count]');
            if (countEl) {
              countEl.setAttribute('data-header-cart-count', cart.item_count);
              countEl.textContent = '(' + cart.item_count + ')';
            }
            var priceEl = document.querySelector('[data-header-cart-price]');
            if (priceEl) priceEl.setAttribute('data-header-cart-price', cart.total_price);
            var fullEl = document.querySelector('[data-header-cart-full]');
            if (fullEl) fullEl.setAttribute('data-header-cart-full', cart.item_count > 1);
            // Hand off to the theme's own drawer flow (open + reload line items).
            // J30 (bd 2i8b.83): theme.js listeners read e.detail.cart (drawer
            // controller theme.js:2696, header count/price :1711, free-shipping
            // :1111) — dispatching without detail threw TypeErrors on every add
            // and left the drawer empty/stale. The fresh /cart.js response is in
            // scope; pass it.
            document.dispatchEvent(new CustomEvent('theme:cart:popdown', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
          });
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[vrec-add]', err && err.message ? err.message : err);
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        // J11 S13: if this add came from a Quick Buy variant popover, close it.
        var pop = btn.closest && btn.closest('[data-qb-popover]');
        if (pop) {
          pop.classList.remove('is-open');
          var qbHome = pop._qbHome || pop.parentElement; // J24: capture before reset restores it
          resetQbPopover(pop);                           // clear fixed styles + move back to its card
          var t = qbHome && qbHome.querySelector('[data-qb-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
  }, true);

  // ============================================================
  // bd a7av.15 — fly-to-cart animation (STKY "add to sticky cart" parity)
  // ------------------------------------------------------------
  // Clones the source product image and animates it to the sticky cart bubble
  // ([data-sticky-cart]); falls back to the header cart when the bubble is hidden
  // (mobile / empty cart / first add). Reduced-motion users skip it entirely.
  // The clone is a transient position:fixed element with NO fixed/absolute
  // descendants, so its transform creates no containing-block trap (kt0-OK).
  // ============================================================
  function flyToCart(btn) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = document.querySelector('[data-sticky-cart]');
    if (!target || !target.getBoundingClientRect().width) {
      target = document.querySelector('[data-header-cart-count]') ||
               document.querySelector('.navlink--cart, [data-drawer-toggle="drawer-cart"]');
    }
    if (!target) return;
    var tRect = target.getBoundingClientRect();
    if (!tRect.width) return;
    var scope = btn.closest('.product-grid-item, [class*="grid-item"], [class*="card"], .vrec-card') || btn.parentElement;
    var img = scope ? scope.querySelector('img') : null;
    if (!img) return;
    var sRect = img.getBoundingClientRect();
    if (!sRect.width) return;
    var clone = img.cloneNode(true);
    clone.className = 'vrec-fly-clone';
    clone.removeAttribute('loading');
    clone.style.cssText = 'position:fixed;z-index:8500;margin:0;left:' + sRect.left + 'px;top:' + sRect.top +
      'px;width:' + sRect.width + 'px;height:' + sRect.height + 'px;border-radius:6px;object-fit:cover;' +
      'pointer-events:none;transition:transform 600ms cubic-bezier(.5,-0.3,.6,1),opacity 600ms ease-in;will-change:transform,opacity;';
    document.body.appendChild(clone);
    var dx = (tRect.left + tRect.width / 2) - (sRect.left + sRect.width / 2);
    var dy = (tRect.top + tRect.height / 2) - (sRect.top + sRect.height / 2);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.15)';
        clone.style.opacity = '0.2';
      });
    });
    var cleaned = false;
    function done() {
      if (cleaned) return; cleaned = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      var bubble = document.querySelector('[data-sticky-cart]');
      if (bubble) { bubble.classList.add('sticky-cart-bubble--bump'); setTimeout(function () { bubble.classList.remove('sticky-cart-bubble--bump'); }, 350); }
    }
    clone.addEventListener('transitionend', done);
    setTimeout(done, 700);
  }

  // ============================================================
  // bd a7av.15 — Skip to Checkout ([data-vrec-checkout], STKY parity)
  // ------------------------------------------------------------
  // The sticky bar's "Buy it now" button (when the theme setting
  // settings.sticky_atc_skip_to_checkout is on) adds the selected variant + qty
  // then redirects to /checkout. Reads the enclosing product form. The native
  // form submit (add to cart) is the JS-off fallback.
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vrec-checkout]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var form = btn.closest('form');
    var idEl = form ? form.querySelector('[name="id"]') : null;
    var id = idEl ? idEl.value : btn.getAttribute('data-variant-id');
    if (!id) return;
    var qtyEl = form ? form.querySelector('[name="quantity"]') : null;
    var qty = (qtyEl && parseInt(qtyEl.value, 10) > 0) ? parseInt(qtyEl.value, 10) : 1;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed: ' + r.status); return r.json(); })
      .then(function () {
        // bd ioba.1: this path jumps straight to /checkout, bypassing both
        // gated checkout buttons. Normally the item just added is a paid
        // product, which un-gates the cart anyway — this is pure defence in
        // case the sticky bar is ever used on a reward gift.
        if (!window.__hmRewardGate) { window.location.href = '/checkout'; return; }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (cart && window.__hmRewardGate.computeGated(cart)) {
              window.__hmRewardGate.show();
              btn.removeAttribute('aria-busy');
              btn.disabled = false;
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(function () { window.location.href = '/checkout'; });
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[vrec-checkout]', err && err.message ? err.message : err);
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  });

  // ============================================================
  // J11 S13 (bd a7av.24) — Quick Buy variant popover
  // ------------------------------------------------------------
  // Multi-variant Quick Buy icons ([data-qb-toggle]) open a small variant
  // selector ([data-qb-popover]); each row is a [data-vrec-add] button handled
  // by §10 above. One popover open at a time; click-outside or a successful
  // add closes it.
  // ============================================================
  // J24 (a7av.33): the popover was clipped wherever a card lives in an
  // overflow scroll-rail (cart-drawer "Complete Your Cart", PDP/home sliders) —
  // the leftmost card lost its variant names off the left edge (even short ones
  // like "100ml"). Product cards/grids establish containing blocks (transform/
  // contain), so a plain position:fixed lands relative to the CARD, not the
  // viewport (measured ~1050px offset). Fix: on open, PORTAL the popover to
  // <body> (escapes every transformed/contained/overflow ancestor) and
  // position:fixed it at the toggle's viewport rect, clamped on-screen + flipped
  // up if no room below. On close, restore it to its card so re-opens + the
  // delegated [data-vrec-add] add-handler keep working.
  function positionQbPopover(toggle, pop) {
    if (pop.parentNode !== document.body) {
      if (!pop._qbHome) pop._qbHome = pop.parentNode;   // remember its card
      document.body.appendChild(pop);
    }
    // J27 (web-team June 25, deck 29/30/31 + iOS videos): the picker must SCROLL
    // WITH its card (not "float"), sit BEHIND the sticky header/search/filter and
    // any signup popup, stay open through scroll, and only close on outside-tap /
    // page-switch / add. On page-scroll surfaces (home/PDP/collection) use
    // position:ABSOLUTE in DOCUMENT space (so it scrolls with the page) at z-index
    // 100 — below header/search (5000-6000), filter (bumped to 200), and popups
    // (9995-9999), yet above the in-flow cards. Inside the CART DRAWER (a fixed
    // overlay whose content scrolls internally) keep position:FIXED + reposition on
    // scroll (the team says it already "works ok" there) above the drawer (20050).
    var inDrawer = !!toggle.closest('.cart__drawer, .drawer__content, .drawer');
    pop._qbFixed = inDrawer;
    pop.style.position = inDrawer ? 'fixed' : 'absolute';
    pop.style.zIndex = inDrawer ? '20100' : '100';
    // box width = the product card's width (STKY parity, J25) so long variant names
    // wrap to fit; align the box to the card's left.
    var card = toggle.closest('.product-grid-item, .vrec-card, [class*="grid-item"], [class*="card"]');
    var tr = toggle.getBoundingClientRect();
    var cr = card ? card.getBoundingClientRect() : tr;
    var vw = document.documentElement.clientWidth, vh = document.documentElement.clientHeight;
    var gap = 6, m = 8;
    var w = Math.min(cr.width, vw - 2 * m);
    pop.style.minWidth = '0';
    pop.style.maxWidth = 'none';
    pop.style.width = Math.round(w) + 'px';              // set width BEFORE measuring height (names wrap)
    var ph = pop.offsetHeight;
    var vLeft = cr.left;                                 // viewport-space, card-left aligned
    if (vLeft + w > vw - m) vLeft = vw - m - w;
    if (vLeft < m) vLeft = m;
    var vTop = tr.bottom + gap;                          // open below the icon…
    if (vTop + ph > vh - m) {                            // …flip above if no room below
      var up = tr.top - ph - gap;
      vTop = (up >= m) ? up : Math.max(m, vh - m - ph);
    }
    if (inDrawer) {                                      // fixed → viewport coords
      pop.style.left = Math.round(vLeft) + 'px';
      pop.style.top = Math.round(vTop) + 'px';
    } else {                                             // absolute → DOCUMENT coords so it scrolls with the page
      var sx = window.pageXOffset || document.documentElement.scrollLeft || 0;
      var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
      pop.style.left = Math.round(vLeft + sx) + 'px';
      pop.style.top = Math.round(vTop + sy) + 'px';
    }
    pop.style.right = 'auto';
    pop.style.bottom = 'auto';
    pop.style.visibility = '';
    // remember the rec rail (if any) so horizontal slider scroll HIDES (not closes) it
    pop._qbRail = toggle.closest('.vrec-slot__rail, .swiper.collection, .flickity-grid[data-slider], [data-slider]');
  }
  function resetQbPopover(pop) {
    pop.style.position = pop.style.left = pop.style.top = pop.style.right = pop.style.bottom = pop.style.zIndex = pop.style.width = pop.style.minWidth = pop.style.maxWidth = pop.style.visibility = '';
    pop._qbRail = null; pop._qbFixed = false;
    if (pop._qbHome && pop.parentNode === document.body) pop._qbHome.appendChild(pop);
  }
  function closeQbPopovers(except) {
    document.querySelectorAll('[data-qb-popover].is-open').forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var home = p._qbHome || p.parentElement;           // capture before reset moves it back
      resetQbPopover(p);
      var t = home && home.querySelector('[data-qb-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-qb-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // J18b (a7av.30): capture-phase + stop so STKY's leftover
                                    // ScriptTag handler can't navigate to the PDP first (preview)
      var pop = toggle.parentElement.querySelector('[data-qb-popover]');
      if (!pop) {
        // J31 (bd 2i8b.91): when OPEN, the popover is portaled to <body> (J24),
        // so the parentElement lookup misses it and re-tapping the toggle icon
        // was a swallowed no-op (stopImmediatePropagation already ran, so the
        // close branch below was dead code and aria-expanded stuck at true).
        // Fall back to the open portaled popover that belongs to THIS toggle.
        var portaled = document.querySelector('body > [data-qb-popover].is-open');
        if (portaled && portaled._qbHome === toggle.parentElement) pop = portaled;
      }
      if (!pop) return;
      var opening = !pop.classList.contains('is-open');
      closeQbPopovers(opening ? pop : null);
      pop.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) positionQbPopover(toggle, pop); else resetQbPopover(pop);
      return;
    }
    // Click anywhere outside an open popover closes it (clicks on a variant row
    // are inside the popover — §10 handles the add; we close it there too).
    if (!(e.target.closest && e.target.closest('[data-qb-popover]'))) {
      closeQbPopovers(null);
    }
  }, true);
  // J27 (web-team June 25): the popover stays OPEN through scrolling — it closes ONLY
  // on outside-tap (handler above), page-switch, or add-to-cart. It NEVER closes on
  // scroll (J24/J25 did, which iOS read as "disappearing"/"floating").
  //   • page-scroll surfaces: position:absolute in document space already tracks the
  //     page on vertical scroll — no reposition needed.
  //   • RESIZE (orientation / iOS address-bar): re-anchor the document coords.
  //   • CART DRAWER (fixed): reposition to follow the toggle on the drawer's internal scroll.
  //   • horizontal REC-RAIL scroll: HIDE (keep open) when the toggle leaves the rail's
  //     visible width; it re-appears when the card scrolls back. rAF-throttled.
  var qbReflowPending = false, qbWantResize = false;
  function reflowOpenQbPopover(e) {
    if (e && e.type === 'resize') qbWantResize = true;
    if (qbReflowPending) return;
    qbReflowPending = true;
    requestAnimationFrame(function () {
      qbReflowPending = false;
      var isResize = qbWantResize; qbWantResize = false;
      var pop = document.querySelector('[data-qb-popover].is-open');
      if (!pop) return;
      var home = pop._qbHome || pop.parentElement;
      var toggle = home && home.querySelector('[data-qb-toggle]');
      if (!toggle) return;
      if (isResize || pop._qbFixed) positionQbPopover(toggle, pop); // re-anchor on resize; follow toggle in the fixed drawer
      if (pop._qbRail) {                                            // hide (keep open) on horizontal rail scroll-off
        var tr = toggle.getBoundingClientRect(), rr = pop._qbRail.getBoundingClientRect();
        pop.style.visibility = (tr.right <= rr.left + 1 || tr.left >= rr.right - 1) ? 'hidden' : '';
      }
    });
  }
  ['scroll', 'resize'].forEach(function (ev) {
    window.addEventListener(ev, reflowOpenQbPopover, true);
  });

  // ============================================================
  // J31 (bd 2i8b.92) — brand-collection mobile filter toggle
  // ------------------------------------------------------------
  // Brand-collection sections render #toggleFilters/#collectionFilters inside
  // LAZY-hydrated content, but shop.js.liquid caches those jQuery selections at
  // document-ready (empty on brand pages) — the mobile filter button was
  // deterministically dead on all 31 brand templates. Bind at hydration time
  // via §8's section:lazy-rendered event (previously dispatched with zero
  // listeners). Scoped to lazy sections only, so eager pages where shop.js DID
  // bind are untouched (no double-toggle); idempotent via a data marker.
  // ============================================================
  document.addEventListener('section:lazy-rendered', function (e) {
    var root = e.target;
    if (!root || !root.querySelector) return;
    var btn = root.querySelector('#toggleFilters');
    var filters = root.querySelector('#collectionFilters');
    if (!btn || !filters || btn.getAttribute('data-hmnl-filters-bound')) return;
    btn.setAttribute('data-hmnl-filters-bound', '1');
    // Mirror shop.js's enquire behavior: filters start hidden on small screens.
    if (window.matchMedia('(max-width: 768px)').matches) filters.style.display = 'none';
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-active');
      var hidden = getComputedStyle(filters).display === 'none';
      filters.style.display = hidden ? 'block' : 'none';
    });
  });

  // ============================================================
  // DEFERRED — vendor-library-dependent scripts (Phase 5 visual QA)
  // ----------------------------------------------------------------
  // The following 4 P6 scripts depend on vendor libraries that P8's stock
  // theme.js doesn't include:
  //
  //   - cross-post-blogs.js  (98 LoC)  — uses Swiper
  //   - banner-slider.js     (23 LoC)  — uses Swiper
  //   - collection-slider.js (99 LoC)  — uses Swiper
  //   - consent-modal.js     (138 LoC) — uses sweetalert2
  //
  // Pipeline 8 ships Flickity (slider) + MicroModal (modal) but the APIs
  // differ from Swiper / sweetalert2. Per-script API translation + visual
  // QA decision deferred to Phase 5 when the dev-theme preview is live.
  //
  // Per-script options (operator picks during P5):
  //   (a) Rewrite using P8 stock equivalents — cleanest, ~3h work per script
  //   (b) Vendor-load Swiper + sweetalert2 from CDN — faster, +90 KB JS
  //   (c) Drop the script, replace behavior with P8 stock equivalent
  //
  // Reference: os2-migration/p4-spike-report.md (vendor-lib analysis).
  // ============================================================

  // ============================================================
  // 11) reward-gate — reward-only checkout gate + redemption reminder
  //     (bd hairmnl-theme-ioba.1, 2026-08-25)
  // ------------------------------------------------------------
  // Two features, one state source:
  //   (a) GATE  — when every line in the cart is a LoyaltyLion reward gift,
  //       the checkout buttons on both surfaces (cart drawer + cart page) are
  //       shown disabled and tapping one opens an explainer instead of
  //       submitting.
  //   (b) REMINDER — once per redemption, when a reward gift newly lands in
  //       the cart, a reminder popup asks the shopper to add a paid item.
  //
  // WHY STATE COMES FROM THE EVENT PAYLOAD, NOT THE DOM.
  // theme.js re-renders only [data-line-items] and [data-cart-subtotal] after
  // an AJAX cart change; the checkout buttons are never replaced, so anything
  // we set on them survives. But the api-cart-* sections do NOT contain the
  // buttons, so the Liquid-rendered initial state would go stale after a
  // quantity change. We therefore recompute from e.detail.cart on every
  // theme:cart:change. See the long re-render warning near the top of
  // snippets/cart-drawer.liquid: a previous attempt that kept a class in sync
  // by reading the DOM shipped a visible bug. Reading the payload also
  // sidesteps the §7 ordering trap — our handlers run before theme.js's
  // CartItems finishes, which only matters if you touch re-rendered DOM.
  //
  // WHY NO LOYALTYLION SDK LISTENERS.
  // LL's shipped bundle does, after mutating the cart:
  //   fire cart.changed -> if nobody is listening, window.location.reload()
  // Registering a cart.changed listener would SUPPRESS that reload and change
  // live behaviour. So we register none, and the reminder is instead made
  // reload-proof: sessionStorage remembers which reward line keys we have
  // already announced, so the popup survives the reload and shows exactly once.
  //
  // TEAM CONSTRAINT (Vikky, 2026-08-25): the reminder must never close or
  // cover LL's own voucher-code window. We hold it while a visible LL modal is
  // on screen and show it only once that window is gone. Our modal is separate
  // DOM and we never call an LL API, so we cannot close theirs even by mistake.
  //
  // DETECTION: reward gifts are identified by vendor / product type, never by
  // price — reward gift prices vary per product (team, 2026-08-25). The Liquid
  // side uses the 'hrewards' tag; /cart.js line items carry no tags, hence the
  // vendor + product_type pair here. cart.total_price === 0 is kept only as a
  // harmless backup for a future pricing setup.
  // ============================================================
  (function () {
    var gateModal = document.getElementById('reward-gate-modal');
    var reminderModal = document.getElementById('reward-reminder-modal');
    var multiModal = document.getElementById('reward-multi-modal');
    // Both modals render only when their theme setting is on, so this is also
    // the feature switch: settings off -> no markup -> section does nothing.
    if (!gateModal && !reminderModal && !multiModal) return;

    var STORE_KEY = 'hmRewardLineKeys';
    var LL_MODAL_SEL = '.lion-modal, [class*="lion-redeem-reward-modal"]';
    var gated = false;
    var gatedReason = '';
    var reminderShownThisPageload = false;

    function isReward(item) {
      if (!item) return false;
      return item.vendor === 'HairMNL Rewards' || item.product_type === 'Promo Tracking';
    }

    // bd 582o: count reward UNITS, not reward LINES. A team screenshot showed a
    // single reward line at quantity 5 — a line-count test would have waved it
    // through, and the LoyaltyLion voucher discounts only one unit, so the
    // shopper was charged for the other four.
    function rewardUnits(cart) {
      var n = 0;
      if (!cart || !cart.items) return 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (isReward(cart.items[i])) n += (cart.items[i].quantity || 1);
      }
      return n;
    }

    // Returns '' (allowed), 'multi-reward', or 'reward-only'. Each modal is
    // rendered only when its setting is on, so a missing modal element IS the
    // off switch for that rule — the same trick that makes the whole section
    // self-disable.
    function gateReason(cart) {
      if (!cart || !cart.items || !cart.items.length) return '';
      if (cart.item_count === 0) return '';
      // Multi-reward first: it is the more specific problem, it applies even
      // when paid items are present, and its explainer is the actionable one.
      if (multiModal && rewardUnits(cart) > 1) return 'multi-reward';
      if (gateModal) {
        if (cart.total_price === 0) return 'reward-only';
        for (var i = 0; i < cart.items.length; i++) {
          if (!isReward(cart.items[i])) return '';
        }
        return 'reward-only';
      }
      return '';
    }

    // Kept as a boolean for the skip-to-checkout guard and existing callers.
    function computeGated(cart) {
      return gateReason(cart) !== '';
    }

    function showModal(id) {
      try {
        if (window.themeVendor && window.themeVendor.MicroModal) {
          window.themeVendor.MicroModal.show(id);
        }
      } catch (err) {
        if (window.console && console.warn) console.warn('[reward-gate] modal', err);
      }
    }

    function applyGate() {
      // Re-query every time: cheap, and immune to any future re-render.
      var buttons = document.querySelectorAll('[data-checkout-gate]');
      for (var i = 0; i < buttons.length; i++) {
        if (gated) {
          buttons[i].classList.add('is-reward-gated');
          buttons[i].setAttribute('aria-disabled', 'true');
        } else {
          buttons[i].classList.remove('is-reward-gated');
          buttons[i].removeAttribute('aria-disabled');
        }
      }
      // Body class drives the defensive express-pay hide (cart state is global).
      if (document.body) document.body.classList.toggle('is-reward-gated', gated);
    }

    // ---- reminder: which reward line keys have we already announced? -------
    function readSeen() {
      try {
        var raw = window.sessionStorage.getItem(STORE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (err) { return []; }
    }
    function writeSeen(keys) {
      try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(keys)); } catch (err) { /* private mode */ }
    }

    function llModalVisible() {
      try {
        var nodes = document.querySelectorAll(LL_MODAL_SEL);
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          var cs = window.getComputedStyle(el);
          var r = el.getBoundingClientRect();
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 2 && r.height > 2) return true;
        }
      } catch (err) { /* fall through: treat as not visible */ }
      return false;
    }

    // Show the reminder, but only once LL's voucher window has gone. If it
    // never resolves we deliberately do nothing AND do not mark the keys as
    // seen, so the reminder simply fires on the shopper's next surface (cart
    // page or drawer) instead of being lost.
    // Team feedback 2026-09-07 (bd ioba.5): the reminder also fires when a
    // regular paid item is already in the cart (by design — the trigger is "a
    // reward newly landed", and the team wants that kept). But the original
    // body says "please add a paid item", which reads wrong then. Two bodies
    // in the snippet; pick the right one from the cart at fire time.
    function pickReminderBody(hasPaid) {
      var want = hasPaid ? 'has-paid' : 'no-paid';
      var ps = reminderModal.querySelectorAll('[data-reminder-body]');
      for (var i = 0; i < ps.length; i++) {
        var on = ps[i].getAttribute('data-reminder-body') === want;
        ps[i].hidden = !on;
        ps[i].style.display = on ? '' : 'none';
      }
    }

    function showReminderWhenClear(newKeys, allKeys, hasPaid) {
      var waited = 0;
      var LIMIT_MS = 30000;
      var STEP_MS = 500;

      function fire() {
        if (reminderShownThisPageload) return;
        reminderShownThisPageload = true;
        writeSeen(allKeys);
        pickReminderBody(hasPaid);
        showModal('reward-reminder-modal');
      }

      if (!llModalVisible()) { fire(); return; }

      var timer = window.setInterval(function () {
        waited += STEP_MS;
        if (!llModalVisible()) { window.clearInterval(timer); fire(); return; }
        if (waited >= LIMIT_MS) { window.clearInterval(timer); /* give up silently */ }
      }, STEP_MS);
    }

    function checkReminder(cart) {
      if (!reminderModal || reminderShownThisPageload) return;
      if (!cart || !cart.items) return;
      var seen = readSeen();
      var all = [];
      var fresh = false;
      var hasPaid = false;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (!isReward(it)) { hasPaid = true; continue; }
        if (!it.key) continue;
        all.push(it.key);
        if (seen.indexOf(it.key) === -1) fresh = true;
      }
      if (!all.length) { writeSeen([]); return; } // rewards gone: reset cleanly
      if (!fresh) { writeSeen(all); return; }     // nothing new: just prune
      showReminderWhenClear(all, all, hasPaid);
    }

    // ---- single source of truth: the cart payload --------------------------
    // Fires on page load too (CartItems.init GETs /cart.js then fireChange), so
    // one listener covers first paint and every later mutation on both surfaces.
    document.addEventListener('theme:cart:change', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (!cart) return;
      gatedReason = gateReason(cart);
      gated = gatedReason !== '';
      applyGate();
      checkReminder(cart);
    });

    // ---- blocking ----------------------------------------------------------
    // Capture phase so we run before the theme's own handlers. aria-disabled
    // (not [disabled]) keeps the button clickable, which is what lets us
    // explain rather than silently do nothing.
    function explain() {
      showModal(gatedReason === 'multi-reward' ? 'reward-multi-modal' : 'reward-gate-modal');
    }

    document.addEventListener('click', function (e) {
      if (!gated) return;
      var btn = e.target.closest && e.target.closest('[data-checkout-gate]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      explain();
    }, true);

    // Enter inside a cart-page quantity field submits the form implicitly. The
    // checkout button precedes the update button in the DOM, so it is the
    // default submitter — but never block an explicit "Update Cart".
    document.addEventListener('submit', function (e) {
      if (!gated) return;
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[data-checkout-gate]')) return;
      if (e.submitter && e.submitter.name && e.submitter.name !== 'checkout') return;
      e.preventDefault();
      e.stopPropagation();
      explain();
    }, true);

    // Exposed for the skip-to-checkout guard below and for headless testing.
    window.__hmRewardGate = {
      computeGated: computeGated,
      gateReason: gateReason,
      rewardUnits: rewardUnits,
      isReward: isReward,
      show: function () { explain(); },
      isGated: function () { return gated; },
      reason: function () { return gatedReason; }
    };
  })();

})();
